module.exports = __webpack_public_path__ + "img/white_email_solid.1b791f54.svg";